import React from 'react';
import ReportLayout, { StatusChip, fmtDateTime, fmtDuration } from './ReportLayout';

const COLUMNS = [
  { key: 'pass_id', label: 'Pass ID', sortable: false },
  { key: 'employee_name', label: 'Employee' },
  { key: 'department', label: 'Department' },
  { key: 'pass_type', label: 'Type', sortable: false, render: v => <StatusChip value={v} /> },
  { key: 'reason', label: 'Reason', sortable: false },
  { key: 'status', label: 'Status', render: v => <StatusChip value={v} /> },
  { key: 'approved_by_name', label: 'Approved By', sortable: false },
  { key: 'supervisor_name', label: 'Supervisor', sortable: false },
  { key: 'created_at', label: 'Requested At', render: v => fmtDateTime(v) },
  { key: 'time_out', label: 'Time Out', sortable: false, render: v => fmtDateTime(v) },
  { key: 'time_in', label: 'Time In', sortable: false, render: v => fmtDateTime(v) },
  { key: 'duration_minutes', label: 'Duration', sortable: false, render: v => fmtDuration(v) },
];

const FILTERS = [
  {
    type: 'select',
    name: 'status',
    label: 'Status',
    defaultValue: 'all',
    options: [
      { value: 'pending', label: 'Pending' },
      { value: 'approved', label: 'Approved' },
      { value: 'out', label: 'Out' },
      { value: 'closed', label: 'Closed' },
      { value: 'rejected', label: 'Rejected' },
      { value: 'cancelled', label: 'Cancelled' },
    ],
  },
  {
    type: 'select',
    name: 'pass_type',
    label: 'Pass Type',
    defaultValue: 'all',
    options: [
      { value: 'official', label: 'Official' },
      { value: 'personal', label: 'Personal' },
    ],
  },
  {
    type: 'departmentSelect',
    name: 'department',
    label: 'Department',
  },
  {
    type: 'userSelect',
    name: 'supervisor_id',
    label: 'Supervisor',
    role: 'supervisor',
  },
];

export default function EmployeeGatePassReport() {
  return (
    <ReportLayout
      title="Employee Gate Passes"
      description="All official and personal exit passes for employees"
      endpoint="/reports/employee-gate-passes"
      columns={COLUMNS}
      filters={FILTERS}
      defaultSort="created_at"
      defaultOrder="desc"
      exportFilename="employee-gate-passes"
    />
  );
}
